<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "app"
};
</script>

<style lang="scss">
@import "@/assets/css/style.scss";

/* App
-------------------------- */
html,
body,
#app {
    height: 100%;
}

*,
*::before,
*::after {
    user-select: none;
    box-sizing: border-box;
    margin: 0;
}

a {
    text-decoration: none;
}

::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    overflow: auto;
}

::-webkit-scrollbar-thumb {
    background-color: #e6e6e6;
    min-height: 25px;
    min-width: 25px;
    border: 1px solid #e0e0e0;
}

::-webkit-scrollbar-track {
    background-color: #f7f7f7;
    border: 1px solid #efefef;
}
</style>
